// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__BXsmx","rootNoMargin":"styles_rootNoMargin__Rh0dh"};